import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyNames } from '@webapp/core/entities/external/Currency'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { CardStatuses } from '@webapp/modules/spending-cards/entities/enums/CardStatusEnum'
import { CardTypes } from '@webapp/modules/spending-cards/entities/enums/CardTypeEnum'
import { IssuingProviders } from '@webapp/modules/spending-cards/entities/enums/IssuingProvider'
import { AdminCard, type AdminCardConstructor } from './AdminCard'

export const AdminCardConstructorFactory =
  Factory.Sync.makeFactory<AdminCardConstructor>({
    id: Factory.each(() => faker.random.number()),
    externalId: Factory.each(() => faker.random.uuid()),
    last4Digits: Factory.each(() => faker.finance.mask(4, false, false)),
    type: Factory.each(() =>
      faker.random.arrayElement(Object.values(CardTypes))
    ),
    provider: IssuingProviders.AIRWALLEX,
    status: CardStatuses.ACTIVE,
    cardholder: Factory.each(() => ({
      id: faker.random.number(),
      userId: faker.random.number(),
      firstName: faker.name.firstName(),
      lastName: faker.name.lastName(),
      email: faker.internet.email(),
      profileImage: faker.image.imageUrl(),
    })),
    createdAt: Factory.each(() => faker.date.past().toISOString()),
    updatedAt: Factory.each(() => faker.date.past().toISOString()),
    balance: Factory.each(() => faker.random.number()),
    currencyName: CurrencyNames.USD,
    requireActivation: false,
    shippingAddress: Factory.each(() => ({
      addressLine1: faker.address.streetAddress(),
      addressLine2: null,
      postalCode: faker.address.zipCode(),
      city: faker.address.city(),
      stateProvince: faker.address.state(),
      country: faker.address.country(),
    })),
  })

export const AdminCardFactory = EntityFactory(
  AdminCard,
  AdminCardConstructorFactory
)
